export const SOCIAL_LINKS = {
  'es-ES': {
    instagram: 'https://www.instagram.com/mammafiore_official/',
    facebook: 'https://www.facebook.com/mammafiore',
    linkedin: 'https://es.linkedin.com/company/mammafiore',
    youtube: 'https://www.youtube.com/@mammafiore_official',
    tiktok: 'https://www.tiktok.com/@hellomamma_es',
  },
  'fr-FR': {
    instagram: 'https://www.instagram.com/mammafiore_official/',
    facebook: 'https://www.facebook.com/mammafiore',
    linkedin: 'https://es.linkedin.com/company/mammafiore',
    youtube: 'https://www.youtube.com/@mammafiore_official',
    tiktok: 'https://www.tiktok.com/@hellomamma_fr',
  },
  'en-GB': {
    instagram: 'https://www.instagram.com/mammafiore_official/',
    facebook: 'https://www.facebook.com/mammafiore',
    linkedin: 'https://es.linkedin.com/company/mammafiore',
    youtube: 'https://www.youtube.com/@mammafiore_official',
    tiktok: 'https://www.tiktok.com/@hellomamma_en',
  },
  'de-DE': {
    instagram: 'https://www.instagram.com/mammafiore_official/',
    facebook: 'https://www.facebook.com/mammafiore',
    linkedin: 'https://es.linkedin.com/company/mammafiore',
    youtube: 'https://www.youtube.com/@mammafiore_official',
    tiktok: 'https://www.tiktok.com/@hellomamma_de',
  },
  'pt-PT': {
    instagram: 'https://www.instagram.com/mammafiore_official/',
    facebook: 'https://www.facebook.com/mammafiore',
    linkedin: 'https://es.linkedin.com/company/mammafiore',
    youtube: 'https://www.youtube.com/@mammafiore_official',
    tiktok: 'https://www.tiktok.com/@hellomamma_pt',
  },
}

export const FOOTER_URLS = {
  'es-ES': '/page/aviso-legal',
  'en-GB': '/page/legal-notice',
  'it-IT': '/page/avviso-legale',
  'fr-FR': '/page/mentions-legales',
  'de-DE': '/page/rechtlicher-hinweis',
  'pt-PT': '/page/aviso-legal'
}
